import './home.css'
import wwwwoohooo from './assets/home/wwwwoohooo.png'

import teksturtitle from './assets/home/teksturtitle.png'


import Footer from './footer'

function TekstUrPrivacy() {
  return (
    <div className="page">
      <div className="main_page">
        <a href="/">
          <img className="woohooologo" src={wwwwoohooo} />
        </a>
      </div>

      <div className="main_page" style={{ paddingBottom: 10, display: 'flex' }}>
        <div className="tekstur" style={{ flex: 1, marginTop: '1vw' }}>
          <a href="/tekstur">
            <img className="teksturtitle2" src={teksturtitle} />
          </a>
          <div className="rankytanksubtitleprivacy" style={{ marginTop: '1vw', marginBottom: '1vw' }}>
            Privacy
          </div>
          {/* <img className="rankytanklogo" src={teksturlogo} /> */}
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div className='privacy_description' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <p className="pheader">Hvad vi indsamler</p>
              <p className="ptext">
                Denne app indsamler, gemmer eller behandler ingen personlige oplysninger. Appen fungerer udelukkende som en visningsløsning (read-only).
              </p>

              <p className="pheader">Hvordan vi bruger data</p>
              <p className="ptext">Da der ikke indsamles nogen data, anvendes der heller ingen oplysninger om brugeren.</p>

              <p className="pheader">Sikkerhed</p>
              <p className="ptext">Da appen ikke gemmer personlige oplysninger, er der ingen brugerdata, som kan kompromitteres.</p>

              <p className="pheader">Dine rettigheder</p>
              <p className="ptext">Du kan bruge appen fuldt ud uden at oprette konto, logge ind eller afgive personlige oplysninger.</p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default TekstUrPrivacy
